import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';

/** Signed PNG, or undefined when the server did not sign (204 or any other non-200 success). Form field `file`, filename `picture.png`, responseType 'blob'. */
export async function signMedia(workflowId: string, nodeId: string, png: Blob): Promise<Blob | undefined> {
  const form = new FormData();
  form.append('file', png, 'picture.png');
  const response = await safeAxios.post<Blob>(API_ROUTES.workflows.nodeMediaSign({ workflowId, nodeId }), form, {
    responseType: 'blob',
    // On a timeout, and on any failure, the caller downloads its local picture; a retry would only upload
    // the picture again.
    timeout: 60_000,
    'axios-retry': { retries: 0 },
  });
  return response.status === 200 ? response.data : undefined;
}
